module.exports = __webpack_public_path__ + "img/event1.a9e905f2.jpg";